module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pinch-in-toparea"
  }, [_c('div', {
    staticClass: "modal-inner flexcenter"
  }, [_c('div', {
    staticClass: "pinch-in"
  }, [_c('button', {
    staticClass: "modal-close",
    on: {
      "click": _vm.clickClose
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pinch-inInner pinch-toparea"
  }, [_c('div', {
    staticClass: "item flexbox"
  }, [(_vm.pathstep.mode == 'STile') ? [_c('div', {
    staticClass: "buttons"
  }, [(_vm.choiceNum == 1) ? [_c('button', {
    staticClass: "icon-num1"
  })] : [_c('button', {
    staticClass: "icon-num2"
  })], _vm._v(" "), _c('button', {
    staticClass: "icon-voice",
    on: {
      "click": _vm.queAudioPlay
    }
  })], 2)] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text",
    class: _vm.getPinchInTextFontClassQue(_vm.pinchInText, _vm.$parent.productLanguage),
    domProps: {
      "innerHTML": _vm._s(_vm.pinchInText)
    }
  }), _vm._v(" "), (_vm.pathstep.mode != 'STile') ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pinchInShowVoice),
      expression: "pinchInShowVoice"
    }],
    staticClass: "icon-voice",
    on: {
      "click": _vm.queAudioPlay
    }
  }) : _vm._e()], 2)])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5081c15a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-5081c15a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/runmode/PinchInQue.vue
// module id = 867
// module chunks = 1